import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-DnXq2BgW.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ar-AE" */'./ar-AE-BRLc0F_r.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--de-DE" */'./de-DE-YJKaJcUk.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-AU" */'./en-AU-tuGQbYHS.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-CA" */'./en-CA-CzkCxX30.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-GB" */'./en-GB-Ba7qiSmj.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-IN" */'./en-IN-BH_LVCt1.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-SG" */'./en-SG-Cl6YR8qv.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-CO" */'./es-CO-VXRw7bM0.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-ES" */'./es-ES-BWJc4xr7.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-MX" */'./es-MX-BQxSgKgs.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--fr-CA" */'./fr-CA-BZqZrL82.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--fr-FR" */'./fr-FR-Ca5vF6rw.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--hi-IN" */'./hi-IN-BDzN186i.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--it-IT" */'./it-IT-DcfaRbnE.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ja-JP" */'./ja-JP-Cu_utb6w.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ko-KR" */'./ko-KR-CaM8Krg_.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--nl-NL" */'./nl-NL-BFhWkjJN.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--pl-PL" */'./pl-PL-CpCfWKmO.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--pt-BR" */'./pt-BR-Cn6I-z2E.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--sv-SE" */'./sv-SE-4NU9gAa2.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ta-IN" */'./ta-IN-Di2xpTS8.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--th-TH" */'./th-TH-DKXsATEp.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--tr-TR" */'./tr-TR-BdMcWU_A.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--vi-VN" */'./vi-VN-RWr6XKM6.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--zh-CN" */'./zh-CN-CchTcCeL.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--zh-TW" */'./zh-TW-D307NfuN.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-BvGP3Evl.js.map
